import React from 'react'
import '../assets/css/banner.css';
import AnimatedBackground from './AnimatedBackground';
import Registration from './Registration';

function Banner(props) {
  return (
    <div>
      <div class="context" >
        <h1>{props.name}</h1>
        <h4 className='px-8'>{props.one_liner}</h4>
        <div className='reg px-5'>
          <Registration link={props.registration_link} name={props.eventName}/>
          
        </div>
          <h4 className='' style={{color:'white'}}> {props.time}</h4>
        <h4 className='' style={{color:'white'}}>{props.venue}</h4>
       
        {/* <div>
          <p>Hello : {props.venue}</p>
        </div> */}
      </div>
      <div className='space'></div>
    </div>
  )
}

export default Banner